
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore-travel-destinations",
      function () {
        return require("private-next-pages/explore-travel-destinations.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore-travel-destinations"])
      });
    }
  